import api from './api'

/**
 * Payment Template Service
 * Handles payment reminder template API calls
 */
class PaymentTemplateService {
  /**
   * Get payment reminder template
   * GET v1/{club}/payment-reminder-template
   */
  async getTemplate(clubUuid: string): Promise<any> {
    const response = await api.get(`v1/${clubUuid}/payment-reminder-template`)
    return response.data
  }

  /**
   * Update payment reminder template
   * PUT v1/{club}/payment-reminder-template
   */
  async updateTemplate(clubUuid: string, template: string): Promise<any> {
    const response = await api.put(`v1/${clubUuid}/payment-reminder-template`, { template })
    return response.data
  }
}

export default new PaymentTemplateService()
